<template>
	<FormKit type="group" name="maritalStatus">
		<FormKit
			v-model="situation"
			name="situation"
			type="select"
			select-icon="down"
			label="Burgerlijke staat"
			placeholder="Kies..."
			:options="situationOptions"
		/>

		<FormKit type="group" name="details">
			<FormKit
				v-if="situation === 'married'"
				type="select"
				select-icon="down"
				name="terms"
				label="Onder welke voorwaarden?"
				placeholder="Kies..."
				:options="termsMarriedOptions"
			/>
			<FormKit
				v-else-if="situation === 'partnership'"
				type="select"
				select-icon="down"
				name="terms"
				label="Onder welke voorwaarden?"
				placeholder="Kies..."
				:options="termsPartnershipOptions"
			/>
			<FormKit
				v-if="situation === 'coliving'"
				type="loanlinkOption"
				name="hasContract"
				label="Met samenlevingscontract?"
				:options="[
					{ label: 'Ja', value: true },
					{ label: 'Nee', value: false },
				]"
			/>
		</FormKit>
	</FormKit>
</template>

<script lang="ts" setup>
import {
	situationOptions,
	termsPartnershipOptions,
	termsMarriedOptions,
} from "@/models/inventarisation/maritalStatusOptions";
import { ref } from "vue";

const situation = ref();
</script>
